var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.75H2.81875L10.15 5.41875L9.08125 4.35L1.75 11.6813V12.75ZM0.25 14.25V11.0625L10.15 1.18125C10.3 1.04375 10.4656 0.9375 10.6469 0.8625C10.8281 0.7875 11.0188 0.75 11.2188 0.75C11.4188 0.75 11.6125 0.7875 11.8 0.8625C11.9875 0.9375 12.15 1.05 12.2875 1.2L13.3188 2.25C13.4688 2.3875 13.5781 2.55 13.6469 2.7375C13.7156 2.925 13.75 3.1125 13.75 3.3C13.75 3.5 13.7156 3.69063 13.6469 3.87188C13.5781 4.05313 13.4688 4.21875 13.3188 4.36875L3.4375 14.25H0.25ZM9.60625 4.89375L9.08125 4.35L10.15 5.41875L9.60625 4.89375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.7afa50a0795de716c9dc7ecfb85801e4.svg";
export { ForwardRef as ReactComponent };